import React, { useState, useEffect } from 'react';
import styles from './CountdownTimer.module.css';
import { RELEASE_DATE } from '../../config';

function getTimeData() {
  const now = new Date();
  const diff = RELEASE_DATE - now;

  if (diff <= 0) {
    const elapsed = now - RELEASE_DATE;
    const totalSec = Math.floor(elapsed / 1000);
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    return { live: true, days, hours, minutes, seconds: totalSec % 60 };
  }

  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  return { live: false, days, hours, minutes, seconds };
}

export default function CountdownTimer() {
  const [data, setData] = useState(getTimeData);

  useEffect(() => {
    const id = setInterval(() => setData(getTimeData()), 1000);
    return () => clearInterval(id);
  }, []);

  const pad = (n) => String(n).padStart(2, '0');

  return (
    <div className={styles.wrapper}>
      <p className={styles.label}>
        {data.live ? 'Server Online' : 'Server Launch In'}
      </p>
      <div className={styles.units}>
        <div className={styles.unit}>
          <span className={styles.value}>{pad(data.days)}</span>
          <span className={styles.unitLabel}>Days</span>
        </div>
        <span className={styles.sep}>:</span>
        <div className={styles.unit}>
          <span className={styles.value}>{pad(data.hours)}</span>
          <span className={styles.unitLabel}>Hours</span>
        </div>
        <span className={styles.sep}>:</span>
        <div className={styles.unit}>
          <span className={styles.value}>{pad(data.minutes)}</span>
          <span className={styles.unitLabel}>Min</span>
        </div>
        <span className={styles.sep}>:</span>
        <div className={styles.unit}>
          <span className={styles.value}>{pad(data.seconds)}</span>
          <span className={styles.unitLabel}>Sec</span>
        </div>
      </div>
    </div>
  );
}
